export const statusForms = [
    'ADCBPMADC',
    'ADCBPMSTATS',
    'SALARYTRANSSTATS',
    'FAQSTATS',
    'PHONEBSTATS',
    'PDPROFSTATS',
    'AFORMSTATS',
    'PURDEMANDSTATS',
    'CCSTATUSES',
    'ORDSTATUS',
    'FOBORDSTATUS',
    'DEALSTATS',
    'PDEALSTATS',
    'PORDSTATS',
    'UIVSTATS',
    'LOANSTATUS',
    'BONUSAGREESTATS',
    'QIVSTATS',
    'BIVSTATS',
    'CPROFSTATS',
    'FOBPROFSTATS',
    'PPROFSTATS',
    'ASSEMBLYSTATUSES',
    'hDOCSTATS',
    'ZDOCSTATS',
    'CONTSTATUSES',
    'FRISTATUSES',
    'FOBDOCSTATS',
    'FIVSTATS',
    'SIVSTATS',
    'AIVSTATS',
    'EIVSTATS',
    'CIVSTATS',
    'YIVSTATS',
    'PIVSTATS',
    'RIVSTATS',
    'DIVSTATS',
    'SALESTARGETSTATS',
    'BOOKSTATS',
    'LEADSTATS',
    'LEASINGSTATUS',
    'CUSTSTATS',
    'PROJVERSTATUSES',
    'BUDVERSIONSTATS',
    'USERSTATUSES',
    'JOBCANDSTATS',
    'PRICELISTSTATS',
    'CONTAINERSTATS',
    'STATUS',
    'DLVTRACKSTATS',
    'eDOCSTATS',
    'mDOCSTATS',
    'CUSTNOTESTATUSES',
    'WTASKSTATS',
    'SALARYSTATS',
    'JOBSTATUSES',
    'TODOLISTCLOSESTATSUS',
    'TODOLISTCLOSESTATS',
    'SUPSTATS',
    'USERSBSTATS',
    'COMSTATS',
    'STEPSTATUSES',
    'SERIALSTATUS',
    'pDOCSTATS',
    'PROJSTATUSES',
    'RRSTATS',
    'TIVSTATS',
    'COURSESTATUSES',
    'CALLSTATUSES',
    'INTERVIEWSTATUSES',
    'QUESTDOCUSTATS',
    'QUESTDOCSTATS',
    'RPROJACTSTATS',
    'ORDISTATUSES',
    'PORDISTATUSES',
    'ECOSTATS',
    'IMPFSTATUS',
    'EXPFSTATUS',
    'FRSTATUSES',
    'DOCSTATUSES',
    'ADOCSTATS',
    'NDOCSTATS',
    'WDOCSTATS',
    'RDOCSTATS',
    'TDOCSTATS',
    'ODOCSTATS',
    'GDOCSTATS',
    'DDOCSTATS',
    'FDOCSTATS',
    'IDOCSTATS',
    'EDOCSTATS',
    'CDOCSTATS',
    'JDOCSTATS',
    'PDOCSTATS',
    'LDOCSTATS',
    'FAULTSTATUSES',
    'SPECIALBUDGETSTATS',
    'HIVSTATS',
    'MRPGANTTUSERSTAT'
];
